import { render, staticRenderFns } from "./SalesOrderClientValidatedStatusBadge.vue?vue&type=template&id=29124395&scoped=true"
import script from "./SalesOrderClientValidatedStatusBadge.vue?vue&type=script&lang=js"
export * from "./SalesOrderClientValidatedStatusBadge.vue?vue&type=script&lang=js"
import style0 from "./SalesOrderClientValidatedStatusBadge.vue?vue&type=style&index=0&id=29124395&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29124395",
  null
  
)

export default component.exports